import React from "react";
import { Award, Shield, Sparkles, Users, Flame, Droplets } from "lucide-react";

export default function Differenciation() {
  const items = [
    { icon: Shield, title: "Garantie décennale", desc: "Toutes nos installations sont couvertes 10 ans." },
    { icon: Sparkles, title: "Marques premium", desc: "Partenaires DAIKIN · MITSUBISHI · HEIWA · HITACHI." },
    { icon: Users, title: "10 ans d'expérience", desc: "François Kloubert et son équipe à votre service." },
    { icon: Award, title: "Travail soigné", desc: "Un travail de qualité, professionnel et reconnu par nos clients." },
  ];
  return (
    <section className="py-20 md:py-24 bg-white" data-testid="differenciation-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-start">
          <div>
            <div className="text-xs md:text-sm uppercase tracking-[0.2em] text-[color:var(--brand-red)] font-semibold mb-3">Pourquoi nous</div>
            <h2 className="font-display text-3xl md:text-5xl font-bold text-[color:var(--brand-navy)] leading-tight">
              Un artisan local<br/>qui <em className="not-italic brand-gradient-text">tient parole</em>.
            </h2>
            <p className="mt-6 text-[hsl(var(--muted-foreground))] text-base md:text-lg leading-relaxed max-w-md">
              Depuis plus de 10 ans, Kloub'Air Plomberie s'est dévouée à apporter le meilleur à ses clients particuliers et professionnels dans les domaines de la climatisation, la plomberie et le chauffage.
            </p>
            <div className="mt-8 flex items-center gap-3">
              <div className="flex -space-x-2">
                <Flame className="w-10 h-10 p-2 rounded-full bg-[color:var(--brand-red)]/10 text-[color:var(--brand-red)]"/>
                <Droplets className="w-10 h-10 p-2 rounded-full bg-[color:var(--brand-sky)]/10 text-[color:var(--brand-sky)]"/>
              </div>
              <div className="text-xs text-[hsl(var(--muted-foreground))] uppercase tracking-wider font-semibold">
                Chauffage · Plomberie · Climatisation
              </div>
            </div>
          </div>
          <div className="grid sm:grid-cols-2 gap-4">
            {items.map((it, i) => (
              <div key={i} className="group p-6 rounded-2xl bg-[hsl(var(--muted))]/40 hover:bg-[color:var(--brand-navy)] hover:text-white transition-all shadow-hover cursor-default">
                <it.icon className="w-7 h-7 text-[color:var(--brand-sky)] group-hover:text-white mb-4"/>
                <h3 className="font-display font-bold text-lg mb-1">{it.title}</h3>
                <p className="text-sm opacity-80 leading-relaxed">{it.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
